import { render, staticRenderFns } from "./adminPersonal.vue?vue&type=template&id=0f829ced&scoped=true"
import script from "./adminPersonal.vue?vue&type=script&lang=js"
export * from "./adminPersonal.vue?vue&type=script&lang=js"
import style0 from "./adminPersonal.vue?vue&type=style&index=0&id=0f829ced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f829ced",
  null
  
)

export default component.exports